import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Sticky, Tabs, Tab, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Text, Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, ProductDiscountLabel, Discount, ProductDetailPrice, ProductDetailUsps, ProductDetailDisclaimer } from '@grandvisionhq/fun-products';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { useLensBundle } from './LensBundles/context.js';
import { LensesProductTitle } from './components/LensesProductTitle/LensesProductTitle.js';
import { LensesStarReview } from './components/LensesStarReview/LensesStarReview.js';
import { ProductImageGalleryContainer } from '../../ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import ConfigureContactLenses from './components/ConfigureContactLenses/ConfigureContactLensesContainer.js';
import { LensesDescription } from './components/LensesDescription/LensesDescription.js';

const Lenses = ({ addToCartRef , contactLensesConfiguratorConfig , ctaButton , currency , deliveryIndicatorConfig , isSmallScreen , isProductLabelEnabled , labels , packPrice , clbbPrice , showStickyButton , stickyTop , variant , activeTabIndex , setActiveTabIndex , isCLBBTabSelected ,  })=>{
    var ref3, ref1;
    const { isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    const { hasCLBBSubscriptions  } = useLensBundle();
    const showDeliveryIndicator = !variant.excludedFromCheckout && !isCLBBTabSelected;
    const packPriceDiscount = packPrice === null || packPrice === void 0 ? void 0 : (ref3 = packPrice.discounted) === null || ref3 === void 0 ? void 0 : ref3.value.centAmount;
    const discountLabel = /*#__PURE__*/ React.createElement(React.Fragment, null, isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    }));
    const hidePackPriceInStickyCta = React.useMemo(()=>{
        var ref;
        const hasQuantityDiscountItems = Boolean((ref = contactLensesConfiguratorConfig.quantityDiscountItems) === null || ref === void 0 ? void 0 : ref.length);
        return hasQuantityDiscountItems;
    }, [
        contactLensesConfiguratorConfig.quantityDiscountItems
    ]);
    var ref2;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-lenses"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(LensesProductTitle, null), /*#__PURE__*/ React.createElement(LensesStarReview, {
        className: "product-detail__review-snippet"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside product-detail-lenses__aside",
        "aria-label": `${variant.brand} ${variant.replacementFrequency}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail-lenses",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, !isSmallScreen && /*#__PURE__*/ React.createElement(LensesProductTitle, null), !isProductLabelEnabled && ((ref1 = variant.tag) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), packPrice && !isCLBBTabSelected && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices",
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        className: "product-detail__price",
        originalPrice: packPrice.value.centAmount,
        currency: currency,
        discountedPrice: packPriceDiscount
    })), discountLabel), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), clbbPrice && isCLBBTabSelected && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        className: "product-detail__price",
        originalPrice: clbbPrice,
        currency: currency
    })), discountLabel), !isSmallScreen && /*#__PURE__*/ React.createElement(LensesStarReview, {
        className: "product-detail__review-snippet"
    }), variant.excludedFromCheckout && /*#__PURE__*/ React.createElement(Text, null, variant.packageQuantity, ' ', variant.packageQuantity === 1 ? labels.lens : labels.lenses, " ", labels.perBox), !variant.excludedFromCheckout && hasCLBBSubscriptions && /*#__PURE__*/ React.createElement(Tabs, {
        onChange: setActiveTabIndex,
        activeTabIndex: activeTabIndex,
        variant: "secondary"
    }, /*#__PURE__*/ React.createElement(Tab, {
        label: labels.oneTimeTitle
    }), /*#__PURE__*/ React.createElement(Tab, {
        label: labels.clbbSubscriptionTitle
    })), !variant.excludedFromCheckout && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__configuration product-detail-lenses__configuration"
    }, /*#__PURE__*/ React.createElement(ConfigureContactLenses, swcHelpers.extends({}, contactLensesConfiguratorConfig, {
        isCLBBTabSelected: isCLBBTabSelected
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details",
        ref: addToCartRef
    }, showDeliveryIndicator && isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "text"
    }))), ctaButton, Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null, isSmallScreen && showStickyButton && !!variant.price && (hidePackPriceInStickyCta ? /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton
    }) : /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (ref2 = packPriceDiscount ? packPriceDiscount : packPrice === null || packPrice === void 0 ? void 0 : packPrice.value.centAmount) !== null && ref2 !== void 0 ? ref2 : 0,
            currency: currency,
            centAmount: true,
            type: packPriceDiscount ? 'discount' : 'default'
        }),
        perBox: labels.perBox
    }))), /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), showDeliveryIndicator && !isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "icon"
    })), /*#__PURE__*/ React.createElement(ProductDetailUsps, null)))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-lenses__description"
    }, /*#__PURE__*/ React.createElement(LensesDescription, null)), /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }));
};
var Lenses$1 = Lenses;

export { Lenses, Lenses$1 as default };
//# sourceMappingURL=Lenses.js.map
